export default __webpack_public_path__ + "static/3_2-d157f8965e147de5db4d2fd2391f57c8.jpg";